import React from "react";
import {Col, Row} from "antd";

import applicationLogo from "../images/unimaze-logo-H-color.png";

import {InjectedIntlProps, injectIntl} from "react-intl";
import {defineMessages} from "react-intl.macro";

const translationMessages = defineMessages(
    {
        umz_header_title: {
            id: "header.umz_header_title",
            defaultMessage: "Business Validation Tool" // Sannreyning EN 16931
        },
        umz_header_title_small: {
            id: "header.umz_header_title_small",
            defaultMessage: "ÍST EN 16931"
        },
        umz_header_subtitle: {
            id: "header.umz_header_subtitle",
            defaultMessage: "Validation of electronic invoice and credit note according to TS 236:2018 Rafrænt reikningaferli"
        },
    });

const UnimazeHeader: React.FC<InjectedIntlProps> = (props) => {
    document.title = props.intl.formatMessage(translationMessages.umz_header_title) + ' ' + props.intl.formatMessage(translationMessages.umz_header_title_small);
    return (<div className={"header"}>
        <Row type="flex" align="middle" className={"headerRow"}>
            <Col span={16}>
                <div>
                    <span style={{textAlign: "left", fontWeight: 700, fontSize: "1.5em"}}>{props.intl.formatMessage(translationMessages.umz_header_title)}</span>
                    <span style={{marginLeft: "1em", textAlign: "left", fontWeight: 700, fontSize: "1em"}}>{props.intl.formatMessage(translationMessages.umz_header_title_small)}</span>
                </div>
                <div>
                    <span style={{textAlign: "left", fontSize: "smaller"}}>{props.intl.formatMessage(translationMessages.umz_header_subtitle)}</span>
                </div>
            </Col>
            <Col span={8} className={"header_right"}>
                <img src={applicationLogo} alt={"Unimaze"} height={"30em"}/>
            </Col>
        </Row>
    </div>);
};

export default injectIntl(UnimazeHeader);
